import React from "react";
import AppModalShell, {
  AppModalButton,
  APP_MODAL_BODY_TEXT_CLASS,
} from "../common/AppModalShell";

export default function AttendanceReviewRequestModal({
  copy,
  item,
  submitting,
  onClose,
  onSubmit,
}) {
  if (!item) return null;

  const eventName = item?.event_preview?.name || item?.event_name || item?.title || "";

  return (
    <AppModalShell
      open={Boolean(item)}
      title={copy.reviewRequestTitle}
      description={eventName}
      onClose={onClose}
      closeAriaLabel={copy.closeAlt}
      zIndexClassName="z-[13000]"
      maxWidthClassName="max-w-[540px]"
      descriptionClassName="text-center"
      footer={
        <div className="grid grid-cols-1 gap-3">
          <AppModalButton
            onClick={onSubmit}
            disabled={submitting}
            loading={submitting}
          >
            {submitting ? copy.reviewRequestSending : copy.reviewRequestCta}
          </AppModalButton>
          <AppModalButton
            variant="secondary"
            onClick={onClose}
            disabled={submitting}
          >
            {copy.reviewRequestCancel}
          </AppModalButton>
        </div>
      }
    >
      <div className="rounded-[18px] border border-white/10 bg-white/[0.07] p-5">
        <div className={APP_MODAL_BODY_TEXT_CLASS}>{copy.reviewRequestDescription}</div>
        <div className={`mt-3 ${APP_MODAL_BODY_TEXT_CLASS}`}>{copy.reviewRequestPenalty}</div>
        {copy.reviewRequestHostNote ? (
          <div className={`mt-3 ${APP_MODAL_BODY_TEXT_CLASS}`}>{copy.reviewRequestHostNote}</div>
        ) : null}
        <div className={`mt-3 ${APP_MODAL_BODY_TEXT_CLASS}`}>{copy.reviewRequestPhotoHint}</div>
      </div>
    </AppModalShell>
  );
}
